/**
 * Created by hernanherreros on 2019-08-31
 */

import * as React from 'react'
import styled from 'styled-components'

import Face1 from '../../static/images/faces/face-1.png'
import Face2 from '../../static/images/faces/face-2.png'
import Face3 from '../../static/images/faces/face-3.png'
import Face4 from '../../static/images/faces/face-4.png'
import Face5 from '../../static/images/faces/face-5.png'

interface Props {
  onSelect: (rating: number) => void;
  selected?: number;
}

export default function RatingHolder ({ onSelect, selected }: Props) {
  return (
    <Container>
      <Face onClick={() => onSelect(1)}>
        <img src={Face1} style={{ width: 45, height: 45, opacity: selected === 1 ? 1 : 0.5 }}/>
      </Face>

      <Face onClick={() => onSelect(2)}>
        <img src={Face2} style={{ width: 45, height: 45, opacity: selected === 2 ? 1 : 0.5 }}/>
      </Face>

      <Face onClick={() => onSelect(3)}>
        <img src={Face3} style={{ width: 45, height: 45, opacity: selected === 3 ? 1 : 0.5 }}/>
      </Face>

      <Face onClick={() => onSelect(4)}>
        <img src={Face4} style={{ width: 45, height: 45, opacity: selected === 4 ? 1 : 0.5 }}/>
      </Face>

      <Face onClick={() => onSelect(5)}>
        <img src={Face5} style={{ width: 45, height: 45, opacity: selected === 5 ? 1 : 0.5 }}/>
      </Face>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
 
  margin: 20px 0;
  margin-bottom: 50px;
`

const Face = styled.button`
  margin-left: 5,
  margin-right: 5,
  background: none;
  outline: none;
  cursor: pointer;
  border: none;
`